import { Button, Container, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import SCCCITitle from '../components/SCCCITitle';
import { login } from '../utils/connect'

// 定义 LoginPage 组件样式
    const LoginContainer = styled(Container)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '30px',
    });

    //const Logo = styled('img')({
    //    display: 'flex',
    //    flexDirection: 'column',
    //    alignItems: 'center',
    //    width: '120px',
    //    marginBottom: '20px',
    //});

    const FormBox = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '20px',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    marginBottom: '20px',
    });

    const LoginButton = styled(Button)({
    marginTop: '20px',
    });

    // LoginPage 组件
    function LoginPage() {
    const { setLogin } = useStateContext();
    const navigate = useNavigate();

    const loginHandler = async () => {
        const user_id = document.querySelector("#user_id").value;
        const password = document.querySelector("#password").value;
        await login(user_id, password);
        navigate("/main/");
    }

    return (
        <LoginContainer maxWidth="xs">
        <SCCCITitle title1={"SCCCI Open House"} title2={"总商会开放日"} date={"May 12-13 2023"}/>
        {/*<Typography variant="h5" align="center">
            SCCCI Open House
        </Typography>
        <Typography variant="subtitle1" align="center" gutterBottom>
            总商会开放日
            <br />
            May 12-13 2023
        </Typography>*/}
        <FormBox>
            <Typography variant="subtitle1" gutterBottom>
            User ID
            </Typography>
            <TextField variant="outlined" margin="dense" id="user_id"/>
            <Typography variant="subtitle1" gutterBottom>
            Password
            </Typography>
            <TextField variant="outlined" margin="dense" type="password" id="password"/>
        </FormBox>
        <LoginButton variant="contained" color="primary" onClick={loginHandler}>
            Sign-in
        </LoginButton>
        </LoginContainer>
    );
}

export default LoginPage;
